import PropTypes from "prop-types";
import React from "react";

import { inputPropTypes } from "@swa-ui/core";
import { TextFormField } from "@swa-ui/form";
import i18n from "@swa-ui/locale";

import {
  STATE_PROVINCE_REGION_MAX_LENGTH,
  STATE_PROVINCE_REGION_SCHEMA_FIELD_NAME,
} from "./StateProvinceRegionFormField.schema";

/**
 * StateProvinceRegionFormField facilitates the input of state name for countries other than US.
 */

export const StateProvinceRegionFormField = (props) => {
  const { componentProps, disabled, name = STATE_PROVINCE_REGION_SCHEMA_FIELD_NAME } = props;

  return <TextFormField {...getTextFormFieldProps()} />;

  function getTextFormFieldProps() {
    return {
      componentProps: {
        "aria-label": i18n("StateProvinceRegionFormField__ARIA"),
        maxLength: STATE_PROVINCE_REGION_MAX_LENGTH,
        ...componentProps,
      },
      disabled,
      label: i18n("StateProvinceRegionFormField__LABEL"),
      name,
    };
  }
};

export const stateProvinceRegionFormFieldPropTypes = {
  /** Component props for input component. */
  componentProps: PropTypes.shape(inputPropTypes),

  /** Indicates whether the field is disabled. */
  disabled: PropTypes.bool,

  /** Form field name used in schema validation and service call payload. */
  name: PropTypes.string,
};

StateProvinceRegionFormField.propTypes = stateProvinceRegionFormFieldPropTypes;
